export enum ProcessEngineActivityId {
    BSI_CALLBACK = 'BsiCallback',
    POST_BSI_CASE = 'PostBsiCase',
}
